<template>
    <div style="margin-top: 50px">
        <h1>Forgotten Password</h1>
        <PasswordForgotForm
            :errors="errors"
            :success-message="
                resetDone
                    ? 'Check your Inbox for the password reset email.'
                    : ''
            "
            @submit-form="submitForm"
        />
    </div>
</template>

<script>
import { useUserStore } from "../../stores/userStore";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import PasswordForgotForm from "js/components/forms/PasswordForgotForm";

export default {
    name: "PasswordForgot",
    components: {
        PasswordForgotForm,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            store: null,
            resetDone: false,
        };
    },
    mounted() {
        this.store = useUserStore();
    },
    methods: {
        submitForm(data) {
            this.store
                .create("api/forgot-password", data)
                .then((result) => {
                    this.resetDone = !!result;
                })
                .catch(this.handleResponseErrors);
        },
    },
};
</script>
